// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/footer/footer-card/footer-card.component.scss
// module id = 299
// module chunks = 0